import React, { useEffect, useRef, useState } from 'react';
import './Valencia.css';
import { useLanguage } from './LanguageContext';
import translations from './translations';

function Valencia() {
  const { language } = useLanguage();
  const t = translations[language];
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const [leftOpacity, setLeftOpacity] = useState(1);
  const [rightOpacity, setRightOpacity] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const calcOpacity = (el) => {
        if (!el) return 1;
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const start = windowHeight * 0.95;
        const end = windowHeight * 0.3;
        const progress = (start - rect.top) / (start - end);
        const clamped = Math.min(Math.max(progress, 0), 1);
        return 1 - clamped; // 1 = fully white, 0 = no overlay
      };

      setLeftOpacity(calcOpacity(leftRef.current));
      setRightOpacity(calcOpacity(rightRef.current));
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="valencia-section">
     <h1 className="valencia-title">
  {t.valenciaTitle[0]} <br />
  {t.valenciaTitle[1]} <br />
  {t.valenciaTitle[2]}
</h1>

      <div className="valencia-grid">
        <div className="val-img-wrap" ref={leftRef}>
          <img src="/ff.png" alt="Fashion 1" />
          <div
            className="val-white-overlay"
            style={{ opacity: leftOpacity }}
          />
         <div className="val-text-box">
  {t.valenciaLeft.map((item, index) => (
    <p key={index}>{item}</p>
  ))}
</div>
        </div>

        <div className="val-img-wrap" ref={rightRef}>
          <img src="/ui.jpg" alt="Fashion 2" />
          <div
            className="val-white-overlay"
            style={{ opacity: rightOpacity }}
          />
         <div className="val-text-box">
  <p>{t.valenciaRight}</p>
</div>
        </div>
      </div>
    </div>
  );
}

export default Valencia;